import { useMemo, useState } from "react";

import { queryGetCorporationGlobalList } from "@type/api/corporation/getCorporationGlobalList";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

import {
  TCorpGlobalListResult,
  TGetCorporationGlobalListReq,
  TGetCorporationGlobalListRes,
} from "@type/api/corporation/types";

interface UseGetBUMemberAssignmentProps {
  payload?: TGetCorporationGlobalListReq;
  onSuccess?: (res: TGetCorporationGlobalListRes) => void;
}

export const useGetCorpGlobalSearchList = ({
  payload,
  onSuccess,
}: UseGetBUMemberAssignmentProps) => {
  const [corpGlobalList, setCorpGlobalList] = useState<TCorpGlobalListResult[]>(
    []
  );
  const queryGetCorporationGlobalListKey = useMemo(() => {
    return queryGetCorporationGlobalList._key(payload);
  }, [payload]);

  const {
    isPending: isLoadingGetCorporationGlobalList,
    refetch: refetchCorpGlobalList,
  } = useQueryWithCallbacks({
    queryKey: queryGetCorporationGlobalListKey,
    queryFn: () => queryGetCorporationGlobalList(payload),
    onSuccess: (res) => {
      onSuccess?.(res);
      setCorpGlobalList(
        res?.data?.map((dt) => {
          return {
            ...dt,
            idUnique: dt.idUnique,
            description: dt.description,
            name: dt.name,
            numOfBusinessEstablishment: dt.numOfBusinessEstablishment,
            numOfJob: dt.numOfJob,
            numOfMember: dt.numOfMember,
            numOfOrganization: dt.numOfOrganization,
            profilePicture: dt.profilePicture,
          };
        }) || []
      );
    },
  });

  return {
    queryGetCorporationGlobalListKey,
    corpGlobalList,
    isLoadingGetCorporationGlobalList,
    refetchCorpGlobalList,
  };
};
